<template>
    <b-modal v-model="modal.ver" title="Caracterización del riesgo" centered hide-footer>
        <!-- Mostrar mensaje si no hay resultados -->
        <div v-if="!hasResults" class="text-center">
            <p>Cargando resultados del análisis.</p>
        </div>

        <!-- Mostrar resultados solo si existen -->
        <div v-else>
            <table v-if="isInhalation" class="table table-striped table-bordered table-hover table-sm">
                <tbody>
                    <tr>
                        <td class="font-weight-bold w-75">TLV [mg/m3] Modificado</td>
                        <td class="text-center">{{ tarea.results.tlv || 'N/A' }}</td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold w-75">Clase de cantidad</td>
                        <td class="text-center">{{ tarea.results.clase_cantidad || 'N/A' }}</td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold w-75">Clase de frecuencia</td>
                        <td class="text-center">{{ tarea.results.clase_frecuencia || 'N/A' }}</td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold w-75">Clase de peligro</td>
                        <td class="text-center">{{ tarea.results.id_clase_peligro || 'N/A' }}</td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold w-75">Clase exposición potencial</td>
                        <td class="text-center">{{ tarea.results.clase_exposicion_potencial || 'N/A' }}</td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold w-75">Clase riesgo potencial</td>
                        <td class="text-center">{{ tarea.results.clase_riesgo_potencial || 'N/A' }}</td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold w-75">Puntuación riesgo potencial</td>
                        <td class="text-center">{{ tarea.results.puntuacion_riesgo_potencial || 'N/A' }}</td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold w-75">Puntuación Volatilidad / Pulverulencia</td>
                        <td class="text-center">{{ tarea.results.puntuacion_pulverulencia || 'N/A' }}</td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold w-75">Puntuación de procedimiento</td>
                        <td class="text-center">{{ tarea.results.puntuacion_procedimiento_colectivo || 'N/A' }}</td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold w-75">Puntuación protección colectiva</td>
                        <td class="text-center">{{ tarea.results.puntuacion_proteccion_colectiva || 'N/A' }}</td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold w-75">Factor conversión TLV</td>
                        <td class="text-center">{{ tarea.results.factor_conversion_tlv || 'N/A' }}</td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold w-75">Puntuación Inhalación</td>
                        <td class="text-center">{{ tarea.results.puntuacion_riesgo || 'N/A' }}</td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold w-75"> Prioridad de acción</td>
                        <td class="text-center">{{ caracterizacionRiesgo.prioridad || 'N/A' }}</td>
                    </tr>
                    <tr :class="claseCaracterizacion()">
                        <td colspan="2" class="text-center font-weight-bold">
                            {{ caracterizacionRiesgo.caracterizacion || 'Sin caracterización' }}
                        </td>
                    </tr>
                </tbody>
            </table>

            <table v-else class="table table-striped table-bordered table-hover table-sm">
                <tbody>
                    <tr>
                        <td class="font-weight-bold w-75">TLV [mg/m3] Modificado</td>
                        <td class="text-center">{{ tarea.results.tlv || 'N/A' }}</td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold w-75">Frecuencia de exposición</td>
                        <td class="text-center">{{ tarea.results.frecuencia_exposicion || 'N/A' }}</td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold w-75">Clase de peligro</td>
                        <td class="text-center">{{ tarea.results.id_clase_peligro || 'N/A' }}</td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold w-75">Puntuación de peligro</td>
                        <td class="text-center">{{ tarea.results.puntuacion_peligro || 'N/A' }}</td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold w-75">Puntuación de superficie</td>
                        <td class="text-center">{{ tarea.results.puntuacion_superficie || 'N/A' }}</td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold w-75">Puntuación de frecuencia</td>
                        <td class="text-center">{{ tarea.results.puntuacion_frecuencia || 'N/A' }}</td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold w-75">Puntuación Dérmico</td>
                        <td class="text-center">{{ tarea.results.puntuacion_riesgo || 'N/A' }}</td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold w-75"> Prioridad de acción</td>
                        <td class="text-center">{{ caracterizacionRiesgo.prioridad || 'N/A' }}</td>
                    </tr>
                    <tr :class="claseCaracterizacion()">
                        <td colspan="2" class="text-center font-weight-bold">
                            {{ caracterizacionRiesgo.caracterizacion || 'Sin caracterización' }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </b-modal>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'modal',
    computed: {
        ...mapState('analysis', ['modal', 'vias_ingreso', 'tarea']),

        hasResults() {
            return this.tarea && this.tarea.results && typeof this.tarea.results === 'object';
        },

        caracterizacionRiesgo() {
            if (this.hasResults && this.tarea.results.caracterizacion_riesgo) {
                return this.tarea.results.caracterizacion_riesgo;
            }
            return {};
        },

        isInhalation() {
            let via_ingreso = this.vias_ingreso.find(vi => vi.id === this.tarea.id_via_ingreso);
            return via_ingreso && via_ingreso.codigo === 'VING01';
        }
    },
    methods: {
        claseCaracterizacion() {
            if (!this.caracterizacionRiesgo.prioridad) {
                return '';
            }

            if (this.caracterizacionRiesgo.prioridad === 1) {
                return 'table-danger';
            } else if (this.caracterizacionRiesgo.prioridad === 2) {
                return 'table-warning';
            }

            return 'table-success';
        }
    }
};
</script>
